<template>
  <div class="content-from-radionica">
    <div class="radionica-inner">
      <h5 class="radionica-header">{{ $t('radionicaHeading1') }} <font-awesome-icon icon="heart" /> {{ $t('radionicaHeading2') }}</h5>
      <hooper :settings="responsiveSettings">
        <slide v-for="(article, index) in articles" v-bind:key="index">
          <div class="article-card">
            <div class="article-content">
              <h4 v-if="lang_current === 'bs'">{{ article.title.bs }}</h4>
              <h4 v-else-if="lang_current === 'en'">{{ article.title.en }}</h4>
              <div class="article-tags" v-if="article.tags">
                <span v-for="(tag, index) in article.tags" v-bind:key="index">
                  {{ tag }}
                </span>
              </div>
              <p v-if="lang_current === 'bs'">{{ article.description.bs }}</p>
              <p v-else-if="lang_current === 'en'">{{ article.description.en }}</p>
            </div>
            <a :href="article.link" class="radionica-link" target="_blank" v-if="article.link">{{ $t('radionicaMore') }}</a>
          </div>
        </slide>
        <hooper-progress slot="hooper-addons"></hooper-progress>
      </hooper>
    </div>
  </div>
</template>

<script>
  import { Hooper, Slide, Progress as HooperProgress } from 'hooper';
  import radionica from '@/radionica/articles.json';
  import i18n from '@/i18n';
  export default {
    name: 'ContentFromRadionica',
    components: {
      Hooper,
      Slide,
      HooperProgress
    },
    data(){
      return{
        responsiveSettings: {
          itemsToShow: 1.1,
          itemsToSlide: 1,
          infiniteScroll: true,
          autoPlay: true,
          centerMode: true,
          wheelControl: false,
          playSpeed: 8000,
          transition: 850,
          hoverPause: false,
          trimWhiteSpace: true,
          shortDrag: true,
          breakpoints: {
            767: {
              itemsToShow: 1.4,
            },
            1023: {
              itemsToShow: 1.6,
            },
            1279: {
              itemsToShow: 1.8,
            }
          }
        },
        articles: radionica.articles
      }
    },
    computed: {
      lang_current () {
        return this.$store.getters.lang
      }
    },
  }
</script>

<style scoped lang="scss">
  .content-from-radionica {
    @apply mx-auto;
    position: relative;
    z-index: 2;

    .radionica-header {
      @apply font-semibold mt-8 text-gold text-2xl text-center uppercase;
      svg {
        @apply mx-1 text-pink;
      }
    }

    .hooper {
      @apply h-auto pb-4;
      &:focus {
        outline: none;
      }

      .hooper-slide {
        @apply flex items-stretch;
        
        * {
          user-select: none;
        }
        
        .article-card {
          @apply flex-col my-4 mx-auto max-w-2xl rounded overflow-hidden shadow-md pb-3 text-center transition-all;
          background: rgba(255,255,255,0.45);
          border-bottom-right-radius: 2% 40%;
          border-bottom-left-radius: 2% 40%;
          border-top-right-radius: 2% 40%;
          border-top-left-radius: 2% 40%;
          background: rgba(255,255,255,0.25);

          .article-tags {
            @apply px-4 pt-3 pb-3;

            span {
              @apply inline-block bg-gold rounded-sm px-2 py-1 text-xs text-white;
              margin: 1px;
            }
          }

          .article-content {
            @apply px-4 py-2;

            h4 {
              @apply text-purple font-semibold text-xl mb-1 mt-2;
            }
            p {
              @apply text-gray-700 text-sm;
            }
          }
          
          .radionica-link {
            @apply inline-block bg-pink mb-3 mt-2 rounded-sm px-4 py-2 text-xs font-semibold text-white transition-colors;

            &:hover {
              @apply bg-cherry;
            }
          }
        }

        &.is-active {
          &.is-current {
            .article-card {
              background: rgba(255,255,255,0.75);
            }
          }
        }
      }
    }

    @screen lg {
      .radionica-header {
        @apply mt-8 text-xl;
      }
      .hooper {
        .hooper-slide {
          .article-card {
            @apply max-w-xl;
          }
        }
      }
    }
    @screen md {
      .radionica-header {
        @apply mt-8 text-xl;
      }
      .hooper {
        .hooper-slide {
          .article-card {
            @apply max-w-lg;
            .article-content {
              h4 {
                @apply text-base;
              }
              p {
                @apply text-sm;
              }
            }
            .article-tags {
              span {
                font-size: 11px;
                padding: 3px 6px;
              }
            }
          }
        }
      }
    }
    @screen sm {
      .radionica-header {
        @apply mt-8 text-xl;
      }
      .hooper {
        .hooper-slide {
          .article-card {
            @apply max-w-sm;
            .article-content {
              h4 {
                @apply text-base;
              }
              p {
                @apply text-xs;
              }
            }
            .article-tags {
              @apply pt-1;
              span {
                font-size: 10px;
                padding: 2px 4px;
              }
            }
          }
        }
      }
    }
  }
</style>

<style lang="css">
  .hooper-slide {
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .hooper-progress {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 4px;
    background-color: #fff;
  }
  .hooper-progress-inner {
    height: 100%;
    background-color: #806543;
    transition: 300ms;
  }
  .hooper-pagination {
    position: absolute;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
    display: flex;
    padding: 5px 10px;
  }
  .hooper-indicators {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .hooper-indicator:hover,
  .hooper-indicator.is-active {
    background-color: #4285f4;
  }
  .hooper-indicator {
    margin: 0 2px;
    width: 12px;
    height: 4px;
    border-radius: 4px;
    border: none;
    padding: 0;
    background-color: #fff;
    cursor: pointer;
  }
  .hooper-pagination.is-vertical {
    bottom: auto;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .hooper-pagination.is-vertical .hooper-indicators {
    flex-direction: column;
  }
  .hooper-pagination.is-vertical .hooper-indicator {
    width: 6px;
  }
  .hooper-next,
  .hooper-prev {
    background-color: transparent;
    border: none;
    padding: 1em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .hooper-next.is-disabled,
  .hooper-prev.is-disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  .hooper-next {
    right: 0;
  }
  .hooper-prev {
    left: 0;
  }
  .hooper-navigation.is-vertical .hooper-next {
    top: auto;
    bottom: 0;
    transform: initial;
  }
  .hooper-navigation.is-vertical .hooper-prev {
    top: 0;
    bottom: auto;
    right: 0;
    left: auto;
    transform: initial;
  }
  .hooper-navigation.is-rtl .hooper-prev {
    left: auto;
    right: 0;
  }
  .hooper-navigation.is-rtl .hooper-next {
    right: auto;
    left: 0;
  }
  .hooper {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 200px;
  }
  .hooper * {
    box-sizing: border-box;
  }
  .hooper-list {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .hooper-track {
    align-items: stretch;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
  .hooper.is-vertical .hooper-track {
    flex-direction: column;
    height: 200px;
  }

  .hooper.is-rtl {
    direction: rtl;
  }

  .hooper-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>